'use client';
import { useRef } from 'react';
import cx from 'classnames';
import { prepareUseInputProps } from '@THC/components/__primitives__/InputWrapper';
import { combineRefs } from '@THC/utils/helpers';
import InputWrapperStyles from './InputWrapper.module.scss';
export const useBaseInput = ({ className, name, props, ref, }) => {
    const inputRef = useRef(null);
    const { disabled, formProps = {}, id, showSeparator = false, size = 'medium', withRef = true, } = props;
    const { input, meta, ...htmlInputProps } = formProps;
    const isDisabled = htmlInputProps.disabled ?? input?.disabled ?? disabled;
    const { asProps, ...rest } = prepareUseInputProps({ ...props, showSeparator, size }, isDisabled);
    return {
        ...rest,
        inputProps: {
            [`data-thc-${name}-size`]: size,
            disabled,
            id,
            ...input,
            ...htmlInputProps,
            ...asProps,
            ...(withRef ? { ref: combineRefs([ref, inputRef]) } : {}),
            className: cx(InputWrapperStyles.input, className),
        },
        size,
    };
};
